<mat-toolbar color="primary">
  <span>Portail des applications</span>
</mat-toolbar>
<div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
  <app-card-link *ngFor="let app of data" fxFlex="25" fxFlex.sm="50" fxFlex.xs="100" [title]="app.title"
    [subTitle]="app.subTitle" [link]="app.link" [img]="app.img" [description]="app.description">
  </app-card-link>
</div>